import type { CSSProperties } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export interface Layout5ThemeColors {
  header: string;
  menu: string;
  primary: string;
  secondary: string;
  button: string;
  title: string;
  text: string;
}

/**
 * Mapeamento de themeColors (igual templates 1 e 2):
 * - header  → fundo da barra principal do header
 * - menu    → fundo da topbar + cor dos links do menu
 * - primary → fundo do footer + destaques/CTAs grandes
 * - button  → botões de ação (buscar, WhatsApp, favoritos badge)
 * - title   → títulos de seção e nomes de veículos
 * - text    → textos de corpo e descrições
 * - secondary → badges e elementos secundários
 */
export function getLayout5ThemeStyle(colors: Layout5ThemeColors): CSSProperties {
  return {
    '--wl5-accent': colors.button,
    '--l5-accent': colors.button,
    '--wl5-primary': colors.primary,
    '--wl5-secondary': colors.secondary,
    '--wl5-button': colors.button,
    '--wl5-title': colors.title,
    '--wl5-text': colors.text,
    '--wl5-muted': colors.text,
    '--wl5-header': colors.header,
    '--wl5-menu': colors.menu,
    '--wl5-accent-bg': `${colors.button}12`,
  } as CSSProperties;
}

export function useLayout5Theme() {
  const { colors } = useTheme();

  return {
    colors,
    themeStyle: getLayout5ThemeStyle(colors),
    headerColor: colors.header,
    menuColor: colors.menu,
    primaryColor: colors.primary,
    secondaryColor: colors.secondary,
    buttonColor: colors.button,
    titleColor: colors.title,
    textColor: colors.text,
  };
}
